import { searchCommonConfig } from './common'

/**
 * Florastory 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: 'linear-gradient(90deg, #13B866 0.03%, #8DDC6C 100%)',
  },
}
